import { userActions } from './reducers';

export const { getCurrentUserAction, setCurrentUserAction, setUserErrorAction, clearCurrentUserAction } = userActions;
